import { useLiveStreamContextData } from "@circle-react/contexts/LiveStreams";

export const useRoom = () => {
  const { room } = useLiveStreamContextData();
  return room;
};
